import { vehicleDataIconMap } from 'src/app/core/services/vehicle-data-collection/vehicle-data-icons/vehicle-data-icon-map';
import { Vehicle } from 'src/app/core/vehicle/vehicle.interface';
import { ObjectStorage } from 'src/app/utils/object-storage/object-storage';

export class VehicleDataCollectionItem {
  public readonly values: string[];
  public readonly isValid: boolean;
  public readonly value: string;
  public readonly key: string;
  public readonly icon: string;
  public readonly label: string;

  public footnotes: string[] = [];

  public constructor(public readonly vehicle: ObjectStorage<Vehicle>, public readonly propertyPaths: string[]) {
    // get values from vehicle for given value paths
    this.values = this.propertyPaths.reduce(
      (values, valuePath) => [
        ...values,
        ...(!!vehicle.get<string>(valuePath) ? [`${vehicle.get<string>(valuePath)}`] : [])
      ],
      []
    );

    this.isValid = !!this.values.length;

    this.key = this.propertyPaths.join(',');

    this.value = this.values.join(', ');

    // get icon for given values
    const engineConcept = vehicle.get<string>('technicalData.engine.engineConcept.id', 'DEFAULT');
    this.icon = vehicleDataIconMap.get(this.key, engineConcept);

    // set translation key for label
    this.label = `vehicle.${this.key}`;
  }
}
